import styled from 'styled-components';
import React, { ReactNode } from 'react';
import { TableBody } from '@ui-library/typography';
import { Flex, FlexProps } from '@ui-library/misc';
import Tooltip from '@ui-library/tooltip';

interface Props extends FlexProps {
  name: string | ReactNode;
  className?: string;
  tooltip?: string;
  children?: ReactNode;
}

const StyledFlex = styled(Flex)`
  > :not(:last-child) {
    margin-right: 0.75em;
    flex-shrink: 0;
  }
`;

const Text = ({ name = '', className = '', tooltip = undefined, children }: Props) => {
  const Label = <TableBody className="text-ellipsis">{name}</TableBody>;
  return (
    <StyledFlex flexDirection="row" alignItemsCenter className={`${className} full-width`}>
      {children}

      {tooltip && tooltip.length > 0 ? <Tooltip title={tooltip}>{Label}</Tooltip> : Label}
    </StyledFlex>
  );
};

export default Text;
